(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[337],{

/***/ "2gPF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Home", function() { return Home; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var Home = function Home(_ref) {
  var title = _ref.title,
      rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["title"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 500 483"
  }, rest), title && __jsx("title", null, title), __jsx("path", {
    d: "M0,199.899703 L0,398.715044 C0,444.738773 37.3096052,482.048378 83.3333333,482.048378 L416.666667,482.048378 C462.690395,482.048378 500,444.738773 500,398.715044 L500,200.960569 C500,173.476908 486.448867,147.760564 463.778872,132.222774 L292.802098,15.0369791 C263.904635,-4.76905292 225.705203,-4.38643343 197.21027,15.9944617 L34.8537161,132.119387 C12.9791933,147.765059 0,173.005805 0,199.899703 Z M221.45008,49.8846188 C235.697546,39.6941712 254.797264,39.5028614 269.245996,49.4058775 L440.222769,166.591672 C451.557767,174.360567 458.333333,187.218739 458.333333,200.960569 L458.333333,398.715044 C458.333333,421.726908 439.67853,440.381711 416.666667,440.381711 L83.3333333,440.381711 C60.3214698,440.381711 41.6666667,421.726908 41.6666667,398.715044 L41.6666667,199.899703 C41.6666667,186.452753 48.1562631,173.832381 59.0935262,166.009543 L221.45008,49.8846188 Z"
  }));
};

/***/ })

}]);